module.exports = __webpack_public_path__ + "img/img3.be25390b.png";